import { render, staticRenderFns } from "./SystemMessage.vue?vue&type=template&id=4c7f0f1b&scoped=true&"
import script from "./SystemMessage.vue?vue&type=script&lang=js&"
export * from "./SystemMessage.vue?vue&type=script&lang=js&"
import style0 from "./SystemMessage.vue?vue&type=style&index=0&lang=less&"
import style1 from "./SystemMessage.vue?vue&type=style&index=1&id=4c7f0f1b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7f0f1b",
  null
  
)

export default component.exports